import { h } from 'preact'
import {AuthorType} from './Types'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props extends AuthorType {
  displayAuthor: boolean
}

const PostAuthorMeta = ({ id, username, reputation, displayAuthor }: Props) => {
  return (
    <div className='post__user__meta'>
      <ul className='list list--dot-seperated text--meta'>
        <li>
          <div className='group--inline'>
            <a href={`/members/reguser01-${id}`}>{ username }</a>
          </div>
        </li>
        {
          displayAuthor ? (
            <li className='list-item--no-dot'>
            <span className='pill pill--author pill--uppercase pill--inline'>
              <Phrase p='Author' />
            </span>
            </li>
          ) : null
        }
        <li className='is-hidden-S'>
          <Phrase p='topic.meta.post.reply' count={{ n: reputation.repliesMade.toString() }} />
        </li>
      </ul>
    </div>
  )
}

export default PostAuthorMeta
